export default __webpack_public_path__ + "static/media/acumen_commverge.20b0c225.png";